(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["notify-me"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('notify-me-form')) {
    class NotifyMeForm extends HTMLElement {
      constructor() {
        super();
        this.submitted = false;
      }

      connectedCallback() {
        this.button = this.querySelector('.notify-me__button');
        this.input = this.querySelector('.notify-me__input');
        this.messageEl = this.querySelector('.notify-me__message');
        this.productId = this.dataset.productId;
        this.productTitle = this.dataset.productTitle;

        this.button.addEventListener('click', (event) => this.handleSubmit(event));
        this.querySelector('form').addEventListener('submit', (event) => this.handleSubmit(event));
      }

      async handleSubmit(event) {
        event.preventDefault();

        if (this.submitted) return;

        if (!this.input.value || !this.input.checkValidity()) {
          this.input.reportValidity();
          return;
        }

        this.submitted = true;
        this.button.disabled = true;

        const payload = {
          products_id: this.productId,
          products_name: this.productTitle,
          customers_email: this.input.value,
          is_notified: 'False',
        };

        try {
          const response = await fetch('https://shopifyapp.ellementry.com/api/notifydata', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });

          const data = await response.json();

          this.showMessage(data.message || (response.ok
            ? 'Request has been submitted, you will be notified when product will be back in stock'
            : 'Something went wrong. Please try again later.'));

          // Both success (201) and duplicate (400) are terminal states in the live UI -
          // button stays disabled either way, matching the reference screenshots.
        } catch (error) {
          console.error('Notify me request failed:', error);
          this.showMessage('Error submitting form. Please try again later.');
          this.submitted = false;
          this.button.disabled = false;
        }
      }

      showMessage(text) {
        this.messageEl.textContent = text;
        this.messageEl.hidden = false;
      }
    }

    customElements.define('notify-me-form', NotifyMeForm);
  }
  } catch(e) { console.error(e); }
})();

})();
